import React from 'react';
import './index.less';
import ABSLabelValue from './ABSLabelValue';
import ABSLabelValueVertical from './ABSLabelValueVertical';
import { IABSLabelValueData } from './interface';
import { findDOMNode } from 'react-dom';
import classNames from 'classnames';

export interface IABSLabelValueListProps {
  list: Array<IABSLabelValueData>;
  className?: string;
}

export interface IABSLabelValueListStates {
  labelValueTitleMinWidth: number;
}

class ABSLabelValueList extends React.Component<IABSLabelValueListProps, IABSLabelValueListStates> {

  labelValueList;

  constructor(props: IABSLabelValueListProps) {
    super(props);
    this.state = {
      labelValueTitleMinWidth: 0,
    };
  }

  componentDidMount() {
    const dom = findDOMNode(this.labelValueList) as Element;
    const labelValueListDom = dom.children; // HTMLCollection(4) [div.abs-label-value, div.abs-label-value, div.abs-label-value, div.abs-label-value]
    const labelValueWidths = [].slice.call(labelValueListDom).map(
      (labelValue) => {
      if (labelValue.childNodes[0].className === 'abs-label-value-vertical-title') {
        return 0;
      }
      return labelValue.childNodes[0].offsetWidth;
    }); // [100, 121, 100, 100];
    const maxLabelValueWidth = Math.max.apply(null, labelValueWidths); // 121

    this.setState({
      labelValueTitleMinWidth: maxLabelValueWidth,
    });
  }

  renderList() {
    const { list } = this.props;
    const { labelValueTitleMinWidth } = this.state;
    return list.map((item, index) => {
      if (item.titleLayout === 'vertical') {
        return <ABSLabelValueVertical item={item} key={index} />;
      }
      return <ABSLabelValue item={item} labelValueTitleMinWidth={labelValueTitleMinWidth} key={index} />;
    }
    );
  }

  render() {
    const { className } = this.props;
    const classes = classNames('abs-label-value-list', className);
    return (
      <div className={classes} ref={view => this.labelValueList = view}>
        {this.renderList()}
      </div>
    );
  }
}
export { IABSLabelValueData };
export default ABSLabelValueList;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSLabelValueList/index.tsx